import { Root, route } from '../utils';

const technicalSupportFormPath = `${Root}technical-support-form`;

export default {
  technicalSupportForm: {
    ...route(technicalSupportFormPath),
  },
};
